import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

function padTo2Digits(num: number) {
    return num.toString().padStart(2, '0');
}

export function getDateFromSap(value: string) {
    try {
        var parts = value.split('-');
        return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    } catch (err) {
        return null;
    }
}

export const formatDate = (value: Date | null, shortDate: Boolean | false) => {
    try {
        if (value == null) return '';

        return [padTo2Digits(value.getDate()), padTo2Digits(value.getMonth() + 1), shortDate ? value.getFullYear().toString().slice(-2) : value.getFullYear()].join('/');
    } catch (err) {
        return '-';
    }
};

/*export function parseDateToString(value: Date | Dayjs | null): string {
    try {
        if (value == null) {
            return '-';
        }

        return value?.toISOString().split('T')[0] ?? '';
    } catch (error) {
        return '--';
    }
}

export function currentDateString(value: Dayjs | null): string {
    try {
        if (null !== value) {
            const year = value.get('year');
            const month = value.get('month') + 1;
            const day = '01';

            return `${year}-${month.toString().padStart(2, '0')}-${day}`;
        }

        return '-';
    } catch (error) {
        return '--';
    }
}*/

export function getYearFromDate(date: string | Date): string {
    try {
        const year = new Date(date).getFullYear();
        return year.toString();
    } catch (error) {
        return '...';
    }
}

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export function isDateInRange(selectedData: string, mesInclusao: string, mesExclusao: string): boolean {
    const date = dayjs(selectedData);
    const start = dayjs(mesInclusao);
    const end = dayjs(mesExclusao);

    return date.isSameOrAfter(start, 'month') && date.isSameOrBefore(end, 'month');
}
